import React, { useCallback, useEffect, useState } from "react";
import { Form, Icon, Menu, Popup, Segment } from "semantic-ui-react";
import { TreeList } from "../../components/TreeList";
import { Report } from "./report";
import { Reports } from "../../api/services/next";
import { onError, onWarning } from "../../components/shared/messages";
import { useTextResources } from "../../language";
import { usePrompt } from "../../hooks/usePrompt";
import { useConfirm } from "../../hooks/useConfirm";
import EntityTypesDropDown from "../../components/shared/EntityTypesDropDown";
import { EntityTypes } from "../../components/shared/constants";

export const ReportList = () => {
    const [selected, setSelected] = useState()
    const [reports, setReports] = useState([])

    const text = useTextResources()
    const prompt = usePrompt()
    const confirm = useConfirm()

    useEffect(()=>{
        try {
            (async ()=>{
                const reports = await Reports.GetReportDefinitions()
                setReports(reports.map(x=>({...x, Definition: x.Definition && JSON.parse(x.Definition)})))
            })()
        }
        catch (error) {
            error.status === 400?onWarning(error):onError(error);
        }
    }, [])

    const addFolder = async (parent)=>{
        const result = await prompt({
            message: text("EnterFolderName")
        })
        if (result) {
            try {
                const folder = await Reports.CreateReportDefinition({
                    ParentFolderId: parent.Id,
                    IsFolder: true,
                    Title: result
                })
                setReports([...reports, folder])
            } catch (error) {
                error.status === 400?onWarning(error):onError(error);
            }
        }
    }
    const addReport = async (parent)=>{
        console.log(parent)
        let entityType = null
        const result = await prompt({
            message: text("EnterReportName"),
            additionalFields: <Form.Field control={EntityTypesDropDown} onChange={value=>entityType = value} label={text("MainEntity")}></Form.Field>
        })
        if (result) {
            try {
                const report = await Reports.CreateReportDefinition({
                    ParentFolderId: parent.Id,
                    IsFolder: false,
                    Title: result,
                    Definition: JSON.stringify({
                        "EntityType": EntityTypes[entityType],
                        "Filters": [],
                        "Fields": []
                    })
                })
                setReports([...reports, report])
            } catch (error) {
                error.status === 400?onWarning(error):onError(error);
            }
        }
    }
    const deleteDefinition = async id=>{
        if(await confirm()){
            try {
                await Reports.DeleteReportDefinition(id)
                setReports(reports.filter(x=>x.Id !== id))
            } catch (error) {
                error.status === 400?onWarning(error):onError(error);
            }
        }
    }

    const itemFormatter = useCallback(({row})=>{
        if (row.IsFolder) {
            return <div>
                {row.Title}
                <Popup on="click" basic position="bottom right" trigger={<Icon style={{float: "right", cursor: "pointer"}} name="ellipsis vertical"/>} content={
                    <Popup.Content>
                    <Menu vertical text>
                        <Menu.Item onClick={()=>addFolder(row)}><Icon style={{float: "right"}} name='folder outline' />{text("AddFolder")}</Menu.Item>
                        <Menu.Item onClick={()=>addReport(row)}><Icon style={{float: "right"}} name='file alternate outline' />{text("AddReport")}</Menu.Item>
                        <Menu.Item disabled={reports.some(x=>x.ParentFolderId == row.Id)} onClick={()=>deleteDefinition(row.Id)}><Icon style={{float: "right"}} name='trash alternate outline' />{text("Delete")}</Menu.Item>
                    </Menu>
                    </Popup.Content>
                } />
            </div>
        } else {
            return <div>
                <a style={{cursor: "pointer"}} onClick={()=>setSelected(row)}> {row.Title}</a>
                <Popup on="click" basic position="bottom right" trigger={<Icon style={{float: "right", cursor: "pointer"}} name="ellipsis vertical"/>} content={
                    <Popup.Content>
                    <Menu vertical text>
                        <Menu.Item onClick={()=>alert(1)}><Icon style={{float: "right"}} name='pencil alternate' />{text("Edit")}</Menu.Item>
                        <Menu.Item onClick={()=>deleteDefinition(row.Id)}><Icon style={{float: "right"}} name='trash alternate outline' />{text("Delete")}</Menu.Item>
                    </Menu>
                    </Popup.Content>
                } />
            </div>
            
        }
    }, [reports])

    return <div style={{ display: "flex", flex: 1, flexDirection: "row", overflow: "hidden"  }}>
        <Segment style={{ width: 350, display: "flex", overflow: "hidden" }}>
            <TreeList formatter={itemFormatter} items={reports} keys={{ link: "ParentFolderId", id: "Id", title: "Title", container: "Folder" }} />
        </Segment>
        <div style={{ display: "flex", flex: 1, paddingLeft: 5, overflow: "hidden"  }}>
            <Report report={selected} />
        </div>
    </div>
}